
  const state = {
    examId:'',
    paperList:[],
    step:{
      configStep:1,
      dataBackfill:false
    },
    examData:{}
  }

  const mutations = {
    setExamId(state,examId){
      state.examId = examId
    },
    setPaperList(state,paperList){
      state.paperList = paperList
    },
    setConfigStep(state,obj){
      state.step = obj
    },
    setExamData(state,data){
      state.examData = data
    }
  }

  export default {
    namespaced: true,
    state,
    mutations
  }


// WEBPACK FOOTER //
// ./src/store/modules/exam.js